import { CustomLink_LinkType } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';
import { SocialLinkType } from './types';

export const SOCIAL_LINKS_SECTION_ID = 'social-links-section';

export const SUPPORTED_SOCIAL_PLATFORM_COUNT = Object.keys(SocialLinkType).length;

export const CUSTOM_LINK_TYPES_WITHOUT_UNSPECIFIED_COUNT = Object.keys(CustomLink_LinkType).length - 1;

export const HTTP_OR_HTTPS_REGEX = /^https?:\/\//i;
export const HTTPS_REGEX = /^https:\/\//i;
